import { type ReactNode, forwardRef, type HTMLAttributes } from 'react'
import { cn } from '#app/utils/tailwind-merge.ts'

export const Field = forwardRef<
	HTMLDivElement,
	HTMLAttributes<HTMLDivElement> & { children: ReactNode }
>(({ className, children, ...props }, ref) => (
	<div ref={ref} className={cn(`space-y-2`, className)} {...props}>
		{children}
	</div>
))
Field.displayName = `Field`
